import { topicsObjType, appTopicsArrType } from '../../types'

const ignore: string[] = [] 

export const ceateTopicArr = (appsArr: { [key: string]: any }, selectedGrades: string) => {

       let obj: topicsObjType = { 
           "שלמים": [], 
           "שבר": [], 
           "גיאומטרייה": [], 
           "נושאים נוספים": [] 
       };
       let arr = Object.keys(obj);

       let appTopicsArr: appTopicsArrType[] = [];


        for (let i = 0; i < appsArr.length; i++) {

            const classIsSelected = selectedGrades === '1234567' || ( appsArr[i].classes.includes(selectedGrades));

            for (let j = 0; j < arr.length; j++) {

               if (appsArr[i].top_topic && appsArr[i].top_topic === arr[j]) {

                   const mainTopic = appsArr[i].top_topic;

                   if (
                       classIsSelected && 
                       appsArr[i].topic.length > 0 &&
                       !obj[mainTopic].includes(appsArr[i].topic) &&
                       !ignore.includes(appsArr[i].topic) 
                     ) {
                       obj[mainTopic].push(appsArr[i].topic);
                   }
                   break;  
               }
               if (
                    classIsSelected && 
                    appsArr[i].topic.length && 
                    !ignore.includes(appsArr[i].topic) &&
                    (j === arr.length - 1) && 
                    !obj["נושאים נוספים"].includes(appsArr[i].topic)
                  ) {
                      obj["נושאים נוספים"].push(appsArr[i].topic);
               }
            }
       }

       for (let k = 0; k < arr.length; k++) {

        const subTopics = obj[arr[k]];

          if (subTopics.length) {

             if ( subTopics.includes('אחר') ){
                subTopics.splice(subTopics.indexOf('אחר'),1);
                subTopics.push('אחר')
             }

             appTopicsArr.push({
                 mainTopic: arr[k], 
                 subTopics: subTopics
             })
          }
       }


       return appTopicsArr;
    
}


export default ceateTopicArr;































/**
 * 
 * 
 * 
 * import { topicsObjType, appTopicsArrType } from '../../types'
import { words }                           from '../dictionary'

const ignore = ["Scale"] 
//const ignore: string[] = [] 

const ceateTopicArr = (appsArr: { [key: string]: any }, selectedGrades: string) => {

       let appTopicsArr: appTopicsArrType[] = [];
       let obj: topicsObjType = { "Integers": [], "Fractions": [], "Geometry": [], "Additional Topics": [] };
       let arr = Object.keys(obj);

        for (let i = 0; i < appsArr.length; i++) {

            const classIsSelected = selectedGrades === '1234567' || appsArr[i].classes.includes(selectedGrades);

            for (let j = 0; j < arr.length; j++) {

               if (appsArr[i].top_topic && appsArr[i].top_topic === words[arr[j]]['heb']) {

                   const mainTopic = words[appsArr[i].top_topic]['eng'];

                   if (
                       classIsSelected && 
                       !obj[mainTopic].includes(words[appsArr[i].topic]['eng']) &&
                       !ignore.includes(words[appsArr[i].topic]['eng']) 
                     ) {
                       obj[mainTopic].push(words[appsArr[i].topic]['eng']);
                   }
                   break;  
               }
               if (
                    classIsSelected && 
                    appsArr[i].topic.length && 
                    !ignore.includes(words[appsArr[i].topic]['eng']) &&
                    (j === arr.length - 1) && 
                    !obj["Additional Topics"].includes(words[appsArr[i].topic]['eng'])
                  ) {
                      obj["Additional Topics"].push(words[appsArr[i].topic]['eng']);
               }
            }
       }

       for (let k = 0; k < arr.length; k++) {
          if (obj[arr[k]].length) {
             appTopicsArr.push({
                 mainTopic: arr[k], 
                 subTopics: obj[arr[k]]
             })
          }
       }

       return appTopicsArr;
    
}


export default ceateTopicArr;




 */